// errors/NotAuthorizedError.ts
import { BaseError } from "@adornis/validation/errors/BaseError.js";
var NotAuthorizedError = class extends BaseError {
  static {
    this._class = "NotAuthorizedError";
  }
  constructor(permission, context, extensions = {}) {
    if (!extensions.translationKey)
      extensions.translationKey = "baseql_notAuthorized";
    extensions.permission = permission;
    extensions.context = context;
    super(`Permission '${permission}' not granted${context ? ` for '${context}'` : ""}`, extensions);
  }
  static createFromDetails(message, extensions) {
    return new this(extensions.permission, extensions.context, extensions);
  }
};
export {
  NotAuthorizedError
};
